import classNames from 'classnames';
import { useTranslation } from '@testsigma/atoms';
import './tour.css';

export const KeyCode = ({ children, className = '' }) => {
  return (
    <span
      className={classNames([
        'text-[11px] border-[0.5px] border-secondary-300 font-bold',
        'min-w-4 h-4 rounded inline-flex justify-center items-center',
        className,
      ])}
    >
      {children}
    </span>
  );
};

export const CommandCenterLaunchTour = () => {
  const { t } = useTranslation();
  const isMac = navigator.userAgent.indexOf('Mac') > -1;

  return (
    <aside
    
      role="complementary"
      aria-label={t('command.center.open_command_center')}
      className={classNames([
        'rotate-border-animation p-[1px] fixed left-[calc(50vw_-_120px)]',
        'bottom-8 overflow-hidden rounded-md shadow-ts w-[240px] text-[11px]',
        'flex gap-1 items-center text-secondary-500 justify-center h-6',
        'font-medium scale-110',
      ])}
    >
      <span>Press</span>
      <KeyCode>{isMac ? '⌘' : <span className='px-1'>Ctrl</span>}</KeyCode>
      <KeyCode>K</KeyCode>
      <span>to open command center</span>
    </aside>
  );
};
